var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI and Keyboard Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4 13.2H1.6V5.2H14.4V13.2ZM8 3.6L6.4 2H1.6C1.17565 2 0.768687 2.16857 0.468629 2.46863C0.168571 2.76869 0 3.17565 0 3.6V13.2C0 13.6243 0.168571 14.0313 0.468629 14.3314C0.768687 14.6314 1.17565 14.8 1.6 14.8H14.4C15.288 14.8 16 14.088 16 13.2V5.2C16 4.77565 15.8314 4.36869 15.5314 4.06863C15.2313 3.76857 14.8243 3.6 14.4 3.6H8ZM7.2 10V8.4H10.4V6L13.6 9.2L10.4 12.4V10H7.2Z",
    fill: "#6B7085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableMoveIcon);
export default __webpack_public_path__ + "static/media/disable-move-icon.31fcc2348cdccd95f30c9ee522e31639.svg";
export { ForwardRef as ReactComponent };